<template>
  <main>
    <div>
      <h2>Direct File Test</h2>
      <div v-if="pending">
        <p>Loading...</p>
      </div>
      <div v-else-if="error">
        <p>Error: {{ error }}</p>
      </div>
      <div v-else-if="content">
        <h1>{{ frontmatter.title }}</h1>
        <div class="content">
          <pre>{{ content }}</pre>
        </div>
      </div>
      <div v-else>
        <p>No content found</p>
      </div>
    </div>
  </main>
</template>

<script setup>
const { data: fileData, pending, error } = await useLazyFetch('/api/content/blog/git/keeping-your-git-repository-clean-and-efficient')

// Parse frontmatter and content
const content = ref('')
const frontmatter = ref({})

if (fileData.value?.content) {
  const lines = fileData.value.content.split('\n')
  let frontmatterEnd = 0
  
  if (lines[0] === '---') {
    for (let i = 1; i < lines.length; i++) {
      if (lines[i] === '---') {
        frontmatterEnd = i + 1
        break
      }
      const [key, ...valueParts] = lines[i].split(':')
      if (key && valueParts.length > 0) {
        frontmatter.value[key.trim()] = valueParts.join(':').trim()
      }
    }
  }
  
  content.value = lines.slice(frontmatterEnd).join('\n').trim()
}
</script>
